import { LinkedIn, GitHub, Instagram, Facebook, Mail, Padding, NextPlan } from '@mui/icons-material';
import { Box, Button, Container, IconButton, TextField } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next'
import SocialLink from './SocialLink';
import { Link, useNavigate } from 'react-router-dom';
import GetCookie from '../Services/GetCookie';
import Data from "../Data/.json"
import logo from "../Files/IBG Logo white.svg"
import services from "../Data/Services.json"
import produits from "../Data/Produits.json"
import { color } from 'framer-motion';



interface Props { }

function Footer(props: Props) {
    const { } = props
    const { t, i18n } = useTranslation();

    const pages = [t("accueil") + '|/', t("apropos") + '|/about', t("services") + '|/services', t("projets") + "|/projects", t("contactM") + "|/contact", t("carriere") + "|/career"];

    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const navigate = useNavigate()

    const cookieMode = GetCookie(Data.mode);
    const handleCloseNavMenu = (link: string) => {
        navigate(link)
        setAnchorElNav(null);
    };
    return (
        <div style={{ color: "white" }}>
            <footer>

                <Container>
                    <div style={{ backgroundColor: "white", width: "100%" }}>.</div>
                    <br /><br />
                    <Box gap={20} sx={{ flexGrow: 1, display: { xs: 'block', md: 'flex' } }}>
                        <Box gap={10} sx={{ flexGrow: 1, display: { xs: 'block', md: 'flex' } }}>
                            <Box borderTop={"1px solid"} paddingTop={"1%"} fontWeight={"lighter"}>
                                <label htmlFor="" style={{ fontWeight: "bold", }}>{t("Texte.Accueil.Partie5.titre")}</label>
                                <br /><br />
                                <label htmlFor="">
                                    {services.map((s: any) =>
                                    (<Box gap={2} display={"flex"}>
                                        <NextPlan style={{ color: "rgba(255, 255, 255, .5)" }} />
                                        {s.title.split("|")[i18n.language == "fr" ? 0 : 1]}
                                        <br /><br />
                                    </Box>)
                                    )}
                                </label>
                            </Box>
                            <Box borderTop={"1px solid"} paddingTop={"1%"} fontWeight={"lighter"}>
                                <label htmlFor="" style={{ fontWeight: "bold", }}>{t("Texte.Accueil.Partie6.titre")}</label>
                                <br /><br />
                                <label htmlFor="">
                                    {produits.map((s: any) =>
                                    (<Box gap={2} display={"flex"}>
                                        <NextPlan style={{ color: "rgba(255, 255, 255, .5)" }} />
                                        {s.title.split("|")[i18n.language == "fr" ? 0 : 1]} <br />
                                        {s.description.split("|")[i18n.language == "fr" ? 0 : 1]} 
                                        <br /><br />
                                    </Box>)
                                    )}
                                </label>
                            </Box>
                            <Box borderTop={"1px solid"} paddingTop={"1%"} fontWeight={"lighter"}>
                                <label htmlFor="" style={{ fontWeight: "bold", }}>{t("Texte.Accueil.Partie7.titre")}</label>
                                <br /><br />
                                <label htmlFor="">
                                    {t("Texte.Accueil.Partie7.contenu")}
                                </label>
                            </Box>
                        </Box>
                        <Box borderTop={"1px solid"} paddingTop={"1%"} fontWeight={"lighter"}>
                            <Box>
                                <label htmlFor="" style={{ fontWeight: "bold", }}>{t("Texte.Accueil.Partie11.titre")}</label>
                                <br /><br />
                                <SocialLink />
                                <br />
                                <label htmlFor="">
                                    {t("Texte.Accueil.Partie11.sousTitre")}
                                </label>
                                <br /><br />
                                <input placeholder={t("placeholderMail")} className='inp' type="text" />
                                <button className='btn'>{t("souscrire")}</button>
                            </Box>
                        </Box>
                    </Box>
                    <br />
                    {/* <SocialLink /> */}
                    <hr />
                    <Box gap={10} display={"flex"}>
                        <img src={logo} alt="" />
                        <label style={{ textAlign: "justify", fontWeight: "lighter", color: "rgba(255, 255, 255, .8)" }} htmlFor="">
                            {t("Texte.Accueil.Partie1.contenu")}
                            <br /><br />
                            <Box sx={{ display: { xs: 'block', md: 'flex' } }} marginLeft={"-5px"} gap={5}>
                                <button className='btn2'>{t("confidentialite")}</button>
                                <button className='btn2'>{t("terme")}</button>
                                <button className='btn2'>{t("cookies")}</button>
                            </Box>
                        </label>
                    </Box>



                </Container>
            </footer>
            <label style={{ left: "2%", color: "white", padding: "10px", position: "absolute" }}>
                {/* @2023 {t('nom')+" "+t("prenom")+". "+t("copyright")+"."} */}
                IBG-Alpha Technology. Copyright © 2025 tous droits reservés
                {/* Build By IBG-Alpha Technologie */}
            </label>
        </div>
    )
}

export default Footer
